export enum COOKIES {
  SMS_LAST_LOGIN = 'sms_last_login',
  IS_NAVBAR_CLOSED = 'isClosedNavigationBar',
}

export enum TRACKING_COOKIES {
  GTM = 'tracking_gtm_enabled',
  //Add other tracking cookies here
  // e.g. ANALYTICS = 'tracking_analytics_enabled',
}
